/**
 * Verifica de forma pontual se uma transação foi confirmada na blockchain.
 *
 * Usa apenas o provider de RPC público configurado em `publicRpcReadOnly`,
 * sem depender do provider da carteira do usuário.
 */
import { getReadOnlyProvider } from '@/utils/publicRpcReadOnly';

/**
 * Verifica se uma transação foi confirmada on-chain.
 *
 * @param {string} txHash - Hash da transação (0x...).
 * @param {string|number|null|undefined} chainId - Chain ID (hex ou numérico).
 * @returns {Promise<boolean>} - `true` se a tx estiver confirmada com status 1; caso contrário `false`.
 */
export async function verifyTransactionOnChain(txHash, chainId) {
  if (!txHash || typeof txHash !== 'string') {
    return false;
  }

  try {
    const provider = getReadOnlyProvider(chainId);
    const receipt = await provider.getTransactionReceipt(txHash);

    return Boolean(receipt && receipt.status === 1);
  } catch (error) {
    // Não devemos quebrar o fluxo principal se o RPC público falhar.
    console.error('[verifyTransactionOnChain] Erro ao verificar transação:', error);
    return false;
  }
}

